/**
 * **A wall's sync line** (E02, Stream E): the sync time bottom-right, always; stale over ten
 * minutes turns it gold, and over thirty the tiles read NO DATA — a wall never shows an old number
 * as if it were now. A read that found nothing is 0; NO DATA is only for no source or no answer.
 */
export type WallFreshness = 'fresh' | 'watch' | 'no data';

export function wallFreshness(syncedAt: Date | null, now: Date): WallFreshness {
  if (!syncedAt) return 'no data';
  const minutes = (now.getTime() - syncedAt.getTime()) / 60_000;
  return minutes > 30 ? 'no data' : minutes > 10 ? 'watch' : 'fresh';
}
